export interface IErrorMesageFormatter {
    error(message: string, eventName: string): any
}

export enum AnalyticsErrorKeys {
    ERROR = 'Error',
    EVENTNAME = 'Event'
}

export class ErrorFormatter implements IErrorMesageFormatter {

    public error(message: string, eventName: string) {
        return {
            [AnalyticsErrorKeys.ERROR]: message,
            [AnalyticsErrorKeys.EVENTNAME]: eventName
        }
    }
}
